import InitialsIcon from "./InitialsIcon";
import classNames from "classnames";
import { PatientDetails, ProviderDetailsResponse } from "../../fay/Api";
import { safelyFormatInitials } from "../initialUtils";
import { AdminProviderDetailsResponse } from "../../fay/generated";

interface UserWithAPIStyleName {
  preferred_first_name: string;
  last_name: string;
  avatar_url: string | null;
}

interface UserWithName {
  firstName: string;
  lastName: string;
  avatarUrl: string | null;
}

export type Size = "small" | "medium" | "large" | "x-large" | "2x-large";

export interface UserAvatarProps {
  user?:
    | UserWithAPIStyleName
    | UserWithName
    | PatientDetails
    | ProviderDetailsResponse
    | AdminProviderDetailsResponse;
  size?: Size;
  hasDot?: boolean;
  className?: string;
  invert?: boolean;
}

const UserAvatar = ({
  user,
  size = "large",
  hasDot,
  className = "",
  invert = false,
}: UserAvatarProps) => {
  const first = user
    ? "firstName" in user
      ? user.firstName
      : user.preferred_first_name
    : "F";
  const last = user
    ? "lastName" in user
      ? user.lastName
      : user.last_name
    : "Y";

  const avatarUrl = user
    ? "avatarUrl" in user
      ? user.avatarUrl
      : "avatar_url" in user
        ? user.avatar_url
        : null
    : null;

  return (
    <div className={classNames(className, styles.avatarContainer(size))}>
      {hasDot && (
        <>
          <div className={styles.dot({ withPing: true })} />
          <div className={styles.dot({ withPing: false })} />
        </>
      )}
      {avatarUrl ? (
        <img
          className="tw-h-full tw-w-full tw-rounded-full tw-object-cover"
          src={avatarUrl}
          alt="Patient avatar"
        />
      ) : (
        <InitialsIcon
          initials={safelyFormatInitials(first, last)}
          size={size}
          invert={invert}
        />
      )}
    </div>
  );
};

const styles = {
  avatarContainer: (type: Size) =>
    classNames(
      {
        small: "tw-h-6 tw-w-6",
        medium: "tw-h-8 tw-w-8",
        large: "tw-h-10 tw-w-10",
        "x-large": "tw-h-32 tw-w-32",
        "2x-large": "tw-h-40 tw-w-40",
      }[type],
      "tw-flex-shrink-0",
      "tw-relative",
    ),
  dot: ({ withPing }: { withPing: boolean }) =>
    classNames(
      "tw-absolute",
      "tw-top-0",
      "tw-left-0",
      "tw-rounded-full",
      "tw-h-2",
      "tw-w-2",
      withPing ? "tw-bg-fay-300" : "tw-bg-fay-500",
      withPing && "tw-animate-ping",
    ),
};

export default UserAvatar;
